import axios from 'axios';
import { getBongoUrl } from '../common/utils/bongo';

export default function (tenant: number, integration: string) {
  return axios
    .get(`${getBongoUrl()}/v1/org/${tenant}/integrations/${integration}/limit`)
    .then((res) => res && res.data)
    .catch((err: any) => {
      const error = err.response && err.response.data;
      throw new Error(error.message);
    });
}
